import { render, staticRenderFns } from "./DotsIcon.vue?vue&type=template&id=78dce393&scoped=true&"
import script from "./DotsIcon.vue?vue&type=script&lang=js&"
export * from "./DotsIcon.vue?vue&type=script&lang=js&"
import style0 from "./DotsIcon.vue?vue&type=style&index=0&id=78dce393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dce393",
  null
  
)

export default component.exports